import React from "react";
import Text from "theme/Text";
import { StyleSheet } from "react-native";
import _ from "lodash";
import { colorList } from "utils/colors";
import HelperString from 'utils/helper-string'
import { Column, Grid, Row } from 'components/atoms/BootstrapGrid'

const ManagementThemedTable = ({ headers = {}, rows = {} }) => {
	
	const createStyles = ( object, style, odd ) => {
		let style_odd = odd ? 'odd' : 'even';
		
		return [
			styles[ object ],
			styles[ `${object}_${style}` ],
			styles[ `${object}_${style}_${style_odd}` ]
		];
	}
	
	const renderRow = ( { items = null, key= null, style = 'normal', odd = true } ) => {
		const cols = _.map( items, ( col_value, col_key ) => {
			col_key = col_key.toString();

			// little bit of manipulation
			switch( true ) {
				case col_key.indexOf( 'percentage' ) !== -1 :
					col_value = `${col_value}%`;
					break;
			}

			return (
				<Column
					style={ createStyles( 'col', style, odd ) }
					key={ HelperString.hash( 'ManagementThemedTableCol', key+col_key)}>
					
					<Text style={ createStyles( 'text', style, odd ) }>
						{ col_value }
					</Text>
				</Column>
			);
		});

		return (
			<Row
				style={ createStyles( 'row', style, odd ) }
				key={ HelperString.hash( 'ManagementThemedTableRow', key)}>
				
				{ cols }
			</Row>
		);
	}

	const renderedHeader = renderRow( {items: headers, style: 'header' } );

	let oddRow = false;
	const renderedRows = _.map( rows, ( values, key ) => {
		oddRow = !oddRow;
		
		return renderRow( {
			items: values,
			key: key,
			odd: oddRow
		} );
	});

	return (
		<Grid
			key={ 'ManagementThemedTable' }>
			
			{/* Filter */}
			{ renderedHeader }
			{ renderedRows }
		</Grid>
	);
}

const styles = StyleSheet.create( {
	row: {},
	row_header: {
		backgroundColor: colorList.PRIMARY.primary
	},
	
	row_normal_odd: {
		backgroundColor: colorList.GREY.light
	},
	
	col: {
		padding: 5
	},
	col_header: {},
	
	text: {},
	text_header: {
		color: colorList.WHITE.primary
	}
} );

export default ManagementThemedTable;
